import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

// match: { params },

export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();

    const match = {
      params,
      isExact: location.pathname === window.location.pathname, // Simulated `isExact`
      path: window.location.pathname, // Current path
      url: window.location.href, // Full URL
    };

    return <Component {...props} router={{ location, navigate }} location={location} match={match} params={params} />;
  }

  return ComponentWithRouterProp;
}
